export default "__VITE_ASSET__DsuOAI9___"